import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'

dayjs?.extend?.(utc)

type StatusVisual = {
  label: string
  tone: string
  cardBackground: string
  cardBorder: string
}

const DEFAULT_STATUS_VISUAL: StatusVisual = {
  label: 'Incomplete Data',
  tone: 'rgba(107, 107, 107, 1)',
  cardBackground: 'rgba(245, 245, 245, 1)',
  cardBorder: 'rgba(181, 177, 174, 1)',
}

const STATUS_VISUALS: Record<string, StatusVisual> = {
  pending_review: {
    label: 'Pending Review',
    tone: 'rgba(237, 108, 2, 1)',
    cardBackground: 'rgba(255, 253, 245, 1)',
    cardBorder: 'rgba(255, 224, 130, 1)',
  },
  approved: {
    label: 'Approved',
    tone: 'rgba(55, 180, 88, 1)',
    cardBackground: 'rgba(241, 248, 233, 1)',
    cardBorder: 'rgba(55, 180, 88, 1)',
  },
  dismissed: {
    label: 'Dismissed',
    tone: 'rgba(178, 0, 3, 1)',
    cardBackground: 'rgba(253, 218, 219, 1)',
    cardBorder: 'rgba(178, 0, 3, 1)',
  },
  regenerating: {
    label: 'Regenerating',
    tone: 'rgba(230, 81, 0, 1)',
    cardBackground: 'rgba(255, 243, 224, 1)',
    cardBorder: 'rgba(255, 152, 0, 1)',
  },
  not_processed: DEFAULT_STATUS_VISUAL,
}

export const statusVisual = (status: string): StatusVisual => {
  return STATUS_VISUALS[status] || DEFAULT_STATUS_VISUAL
}

export const formatDate = (value?: string | null): string => {
  if (!value) return '—'
  const parsed = dayjs.utc(value)
  return parsed.isValid() ? parsed.format('MMM D, YYYY [at] h:mm A') : '—'
}

export const statusColor = (status: string): string => {
  return statusVisual(status).tone
}

export const statusLabel = (status: string): string => {
  return statusVisual(status).label
}
